import dayjs from "dayjs";

import i18n from "../i18n";

import formatDate, { EFormats } from "./formatDate";

export type DateInfo = {
  created_at?: string | Date;
  modified_at?: string | Date;
};

export const getFormattedDateChange = ( { created_at, modified_at }: DateInfo):string => {
  const created = created_at ? dayjs(created_at) : null;
  const modified = modified_at ? dayjs(modified_at) : null;

  const isModifiedLater =
    created && modified && created.isValid() && modified.isValid() && modified.isAfter(created);

  const label = i18n.t(isModifiedLater ? "amlRiskSettings.lastModified" : "common.createdAt");
  const dateToFormat = isModifiedLater ? modified_at : created_at;

  return `${label}: ${dateToFormat ? formatDate(dateToFormat, EFormats.D) : ""}`;
};
